import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap";
import DashboardStatBox from "./DashboardStatBox";
import { DashboardComparisonChart } from "./DashboardCharts";
import { formatHours, formatPercent } from "./dashboardStatisticsUtils";

const UserDashboardView = ({ data }) => {
  const { t } = useTranslation();
  const d = data;

  return (
    <>
      <Card className="shadow-sm border-0 mb-4 analytics-card">
        <Card.Header className="bg-light border-0 py-2 px-2 px-md-3">
          <span className="fw-semibold text-secondary small text-uppercase">
            <i className="bi bi-person-badge me-2" />
            {t("app.analytics.mySummary")}
          </span>
        </Card.Header>
        <Card.Body className="pt-2 pb-3 px-2 px-md-3">
          <Row className="g-2 g-md-3">
            <DashboardStatBox value={formatHours(d.totalHoursWorked)} label={t("app.analytics.totalHoursWorked")} icon="bi-hourglass-split" iconColor="#4A90E2" background="rgba(74, 144, 226, 0.08)" />
            <DashboardStatBox value={d.submittedTimeSheets} label={t("app.analytics.submittedTimeSheets")} icon="bi-file-earmark-text" iconColor="#FFA726" background="rgba(255, 167, 38, 0.08)" />
            <DashboardStatBox value={formatPercent(d.attendanceRatePercent)} label={t("app.analytics.attendanceRate")} icon="bi-person-check" iconColor="#66BB6A" background="rgba(102, 187, 106, 0.08)" />
            <DashboardStatBox value={d.documentsUploaded} label={t("app.analytics.documentsUploaded")} icon="bi-file-earmark-arrow-up" iconColor="#4ECDC4" background="rgba(78, 205, 196, 0.08)" />
            <DashboardStatBox value={d.leaveDaysInPeriod} label={t("app.analytics.leaveDaysInPeriod")} icon="bi-calendar-x" iconColor="#E57373" background="rgba(229, 115, 115, 0.08)" />
            <DashboardStatBox value={d.pendingLeaveRequests} label={t("app.analytics.pendingLeaveRequests")} icon="bi-hourglass-split" iconColor="#FFD54F" background="rgba(255, 213, 79, 0.08)" />
            <DashboardStatBox value={d.assignedProjects} label={t("app.analytics.assignedProjects")} icon="bi-kanban" iconColor="#BA68C8" background="rgba(186, 104, 200, 0.08)" />
            <DashboardStatBox value={d.teamCount} label={t("app.analytics.teamCount")} icon="bi-people" iconColor="#4DD0E1" background="rgba(77, 208, 225, 0.08)" />
          </Row>
        </Card.Body>
      </Card>

      <Row>
        <Col xs={12} md={8} lg={6}>
          <DashboardComparisonChart
            title={t("app.analytics.myActivity")}
            icon="bi-activity"
            bars={[
              { key: "hours", label: t("app.analytics.hoursShort"), value: Math.min(Math.round(d.totalHoursWorked), 200), displayValue: formatHours(d.totalHoursWorked), color: "#4A90E2" },
              { key: "timesheets", label: t("app.analytics.timesheetsShort"), value: d.submittedTimeSheets, color: "#FFA726" },
              { key: "leave", label: t("app.analytics.leaveDaysShort"), value: d.leaveDaysInPeriod, color: "#E57373" },
              { key: "docs", label: t("app.analytics.documentsShort"), value: d.documentsUploaded, color: "#4ECDC4" },
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

export default UserDashboardView;
